import React from "react";

import FlowSvg from "../../assets/images/icons/flow-1.svg";

export const Flow1Icon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={FlowSvg}
        alt={alt || "Flow"}
    />
);
